import { useEffect, useRef } from "react";

const eventEmitter = new EventTarget();

export default function useEventEmitter(
  event: string,
  onEvent: (data: any) => void
) {
  const eventRef = useRef(event);
  const onEventRef = useRef(onEvent);

  useEffect(() => {
    const currentEvent = eventRef.current;

    const handler = (e: Event) => {
      const customEvent = e as CustomEvent;
      onEventRef.current(customEvent.detail);
    };

    // Add the event listener
    eventEmitter.addEventListener(currentEvent, handler);

    // Remove the event listener
    return () => {
      eventEmitter.removeEventListener(currentEvent, handler);
    };
  }, []);
}

// Function to emit events
export const emitEvent = (event: string, data?: any) => {
  const customEvent = new CustomEvent(event, { detail: data });
  eventEmitter.dispatchEvent(customEvent);
};
